import Landing from "../../pages/public/Landing";
import Login from "../../pages/auth/Login";
import Register from "../../pages/auth/Register";
import Forgot from "../../pages/auth/Forgot";
import Dashboard from "../../pages/dashboard/Dashboard";
import PublicLayout from "../layouts/PublicLayout";
import AuthLayout from "../layouts/AuthLayout";
import DashboardLayout from "../layouts/DashboardLayout";
import PrivateRoute from "./PrivateRoute";
import Projects from "../../pages/dashboard/Projects";
import Settings from "../../pages/dashboard/Settings";
import ProjectDetails from "../../pages/dashboard/ProjectDetails";
import DashboardDocs from "../../pages/dashboard/Docs";
import PublicDocs from "../../pages/public/Docs";
import CliAuth from "../../pages/auth/CliConnect";
import ResetPassword from "../../pages/auth/ResetPassword";
import PrivacyPolicy from "../../pages/legal/PrivacyPolicy";
import TermsOfService from "../../pages/legal/TermsOfService";
import Security from "../../pages/legal/Security";
import UserSupportPage from "../../pages/dashboard/UserSupport";
import RefundPolicy from "../../pages/legal/RefundPolicy";
import SubscriptionPage from "../../pages/dashboard/SubscriptionPage";

export const routes = [
  {
    element: <PublicLayout />,
    children: [
      { path: "/", element: <Landing /> },
      { path: "cli", element: <CliAuth /> },
      { path: "docs", element: <PublicDocs />, handle: { title: "Documentation | EnvDock CLI & API" } },
      { path: "privacypolicy", element: <PrivacyPolicy /> },
      { path: "terms", element: <TermsOfService /> },
      { path: "refund-policy", element: <RefundPolicy /> },
      { path: "security", element: <Security /> },

    ]
  },
  {
    path: "/",
    element: <AuthLayout />,
    children: [
      { path: "login", element: <Login /> },
      { path: "register", element: <Register /> },
      { path: "forgot", element: <Forgot /> },
      { path: "/auth/reset-password/:token", element: <ResetPassword /> },
    ]
  },
  {
    element: <PrivateRoute />,
    children: [
      {
        path: "/dashboard",
        element: <DashboardLayout />,
        children: [
          { index: true,path: "home", element: <Dashboard /> },
          { path: "settings", element: <Settings /> },
          { path: "projects", element: <Projects /> },
          { path: "docs", element: <DashboardDocs /> },
          { path: "support", element: <UserSupportPage /> },
          { path: "subscription", element: <SubscriptionPage /> },
          { path: "projects/:id", element: <ProjectDetails /> },

        ]
      }
    ]
  }
];
